import React, { forwardRef } from 'react';
import { Select } from 'antd';

const OrganizationSelect = forwardRef(({ organizations, onChange, value }, ref) => {
	if (!organizations) {
		return null;
	}

	return (
		<Select ref={ref} optionFilterProp='label' onChange={onChange} defaultValue={value} showSearch>
			{organizations.map((organization) => (
				<Select.Option key={organization.id} value={organization.id} label={organization.name}>
					<span style={{ width: 60, display: 'inline-block' }}>{organization.id}</span>{' '}
					{organization.name}
				</Select.Option>
			))}
		</Select>
	);
});

export default OrganizationSelect;



// WEBPACK FOOTER //
// ./src/components/OrganizationSelect.jsx